import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import Overview from 'pages/Entity/Release/Overview/index';
import VersionOverview from 'pages/Entity/Release/Version/Overview';
import Performance from 'pages/Entity/Release/Performance/index';
import Airplay from 'pages/Entity/Release/Airplay/index';
import VersionPerformance from 'pages/Entity/Release/Version/Performance';
import Territory from 'pages/Entity/Release/Shared/Territory';
import Charts from 'pages/Entity/Release/Charts/index';
import VersionCharts from 'pages/Entity/Release/Version/Charts';
import VersionAirplay from 'pages/Entity/Release/Version/Airplay';
import Social from 'pages/Entity/Release/Social/index';
import Audience from 'pages/Audience';

interface IReleaseProps {
  location: any;
  pathPrefix: string;
  loading: boolean;
  artistMetadata: any;
}

const Release: React.FC<IReleaseProps> = (props) => {
  const { location, pathPrefix, artistMetadata } = props;

  return (
    <Switch location={location}>
      <Route
        path={`${pathPrefix}/release/:entityId/overview`}
        render={(routerProps): any => (
          <Overview
            {...routerProps}
            pathPrefix={pathPrefix}
            artistMetadata={artistMetadata}
          />
        )}
      />
      <Route
        path={`${pathPrefix}/release/:parentEntityId/version/:entityId/overview`}
        render={(routerProps): any => (
          <VersionOverview
            {...routerProps}
            pathPrefix={pathPrefix}
            artistMetadata={artistMetadata}
          />
        )}
      />
      <Route
        path={`${pathPrefix}/release/:entityId/performance`}
        render={(routerProps): any => (
          <Performance
            {...routerProps}
            pathPrefix={pathPrefix}
            artistMetadata={artistMetadata}
          />
        )}
      />
      <Route
        path={`${pathPrefix}/release/:parentEntityId/version/:entityId/performance`}
        render={(routerProps): any => (
          <VersionPerformance {...routerProps} pathPrefix={pathPrefix} />
        )}
      />

      <Route
        path={`${pathPrefix}/release/:entityId/charts`}
        render={(routerProps): any => (
          <Charts {...routerProps} pathPrefix={pathPrefix} />
        )}
      />
      <Route
        path={`${pathPrefix}/release/:parentEntityId/version/:entityId/charts`}
        render={(routerProps): any => (
          <VersionCharts {...routerProps} pathPrefix={pathPrefix} />
        )}
      />
      <Route
        path={`${pathPrefix}/release/:entityId/airplay`}
        render={(routerProps): any => (
          <Airplay {...routerProps} pathPrefix={pathPrefix} />
        )}
      />
      <Route
        path={`${pathPrefix}/release/:parentEntityId/version/:entityId/airplay`}
        render={(routerProps): any => (
          <VersionAirplay {...routerProps} pathPrefix={pathPrefix} />
        )}
      />
      <Route
        path={`${pathPrefix}/release/:entityId/social`}
        render={(routerProps): any => (
          <Social {...routerProps} pathPrefix={pathPrefix} />
        )}
      />
      <Route
        exact
        path={`${pathPrefix}/release/:parentEntityId/version/:entityId/social`}
        render={(routerProps): any => <Social {...routerProps} />}
      />
      <Route
        exact
        path={`${pathPrefix}/release/:entityId/audience/ageGender`}
        render={(routerProps: any): any => <Audience {...routerProps} />}
      />
      <Route
        exact
        path={`${pathPrefix}/release/:parentEntityId/version/:entityId/audience/ageGender`}
        render={(routerProps): any => <Audience {...routerProps} />}
      />

      <Route
        exact
        path={`${pathPrefix}/release/:entityId/audience/territory`}
        render={(routerProps): any => <Territory {...routerProps} />}
      />
      <Route
        exact
        path={`${pathPrefix}/release/:parentEntityId/version/:entityId/audience/territory`}
        render={(routerProps): any => <Territory {...routerProps} />}
      />
      <Redirect
        exact
        from={`${pathPrefix}/release/:entityId/audience`}
        to={`${pathPrefix}/release/:entityId/audience/ageGender`}
      />
      <Redirect
        exact
        from={`${pathPrefix}/release/:parentEntityId/version/:entityId/audience`}
        to={`${pathPrefix}/release/:parentEntityId/version/:entityId/audience/ageGender`}
      />
    </Switch>
  );
};

export default Release;
